import api from './client'

export const login  = (username, password) =>
  api.post('/api/auth/token/', { username, password })
export const getMe  = (config) => api.get('/api/auth/me/', config)
export const getAuthProviders = (config) => api.get('/api/auth/providers/', config)
export const googleLogin = (idToken) =>
  api.post('/api/auth/google/', { id_token: idToken })
export const telegramWidgetLogin = (userData) =>
  api.post('/api/auth/telegram/widget/', userData)
export const telegramOidcLogin = (code, redirectUri, codeVerifier) =>
  api.post('/api/auth/telegram/oidc/', { code, redirect_uri: redirectUri, code_verifier: codeVerifier })

